import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {LEGACY_FONT_PROXIMA_14} from 'styles/FontConstants';
import * as Colors from 'ui-library/Colors';
import Modal, {ModalBodyColor} from 'ui-library/modals/Modal';

interface SavedSearchModalHelpScreenProps {
  closeModal: () => void;
}

export function SavedSearchModalHelpScreen(props: SavedSearchModalHelpScreenProps): JSX.Element {
  return (
    <Modal
      onRequestClose={props.closeModal}
      title="Saved Searches"
      mediumLarge={true}
      fullHeight={true}
      centerBody={true}
      modalBodyBgColor={ModalBodyColor.GRAY_LIGHTER}
    >
      <div className={css(styles.body)}>
        <div className={css(styles.frame)}>
          <span className={css(styles.heading)}>You haven't saved any searches yet.</span>
          <span className={css(styles.upperText)}>
            Use saved searches to easily access frequently-needed views of your Benchling data.
          </span>
          <span className={css(styles.upperText)}>
            Once you’ve entered search criteria you’ll need again, click “Save” at the top of the screen, and
            you’ll be able to open that search from here.
          </span>
          <img className={css(styles.saveButtonImage)} src="/static/img/save_help.png" />

          <hr className={css(styles.hr)} />
          <span className={css(styles.bottomText)}>
            Use the “Share” button at the top-right of the screen to let your teammates run your searches
            themselves.
          </span>
          <img className={css(styles.shareButtonImage)} src="/static/img/share_help.png" />
        </div>
      </div>
    </Modal>
  );
}

const styles = StyleSheet.create({
  frame: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '24px',
    maxWidth: '525px',
    width: '100%',
  },
  body: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    marginTop: 'auto',
    marginBottom: 'auto',
  },
  upperText: {
    textAlign: 'center',
    ...LEGACY_FONT_PROXIMA_14,
    color: 'black',
  },
  bottomText: {
    textAlign: 'center',
    ...LEGACY_FONT_PROXIMA_14,
    color: 'black',
    maxWidth: '385px',
    width: '100%',
  },
  saveButtonImage: {
    maxWidth: '434px',
    width: '100%',
  },
  shareButtonImage: {
    maxWidth: '274px',
    width: '100%',
  },
  heading: {
    textAlign: 'center',
    fontSize: '22px',
    lineHeight: '26px',
  },
  hr: {
    maxWidth: '492px',
    width: '100%',
    borderTopColor: Colors.GRAY,
  },
});
